<ng-container *ngIf="!shouldHide">
    <div *ngIf="recommendations.length > 0" class="section section-white product-recommendations-section">
        <div class="container product-recommendations-container">
            <app-frequently-bought-together
                [source]="'Frequently Bought Together - Product Page'"
                [recommendations]="recommendations"
                *ngIf="recommendationType === 'frequentlyBoughtTogether'"
            >
            </app-frequently-bought-together>

            <app-related-products
                [source]="'Related Products - Product Page'"
                [recommendations]="recommendations"
                *ngIf="recommendationType === 'related'"
                (addedToCart)="addedToCart($event)"
            ></app-related-products>

            <app-trending-products
                [source]="'Trending Products - Category Page'"
                [recommendations]="recommendations"
                *ngIf="recommendationType === 'trending'"
                (addedToCart)="addedToCart($event)"
            ></app-trending-products>
        </div>
    </div>

    <app-add-to-cart-confirmation-dialog
        *ngIf="addToCartConfirmationDto"
        [addToCartConfirmationDto]="addToCartConfirmationDto"
        (hidden)="hideAddedToCartConfirmation()"
    ></app-add-to-cart-confirmation-dialog>
</ng-container>
